import {
  QueryCache,
  QueryClient,
  QueryClientConfig,
  QueryClientProvider,
} from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { InterceptedAPIStatus } from 'components/APIErrorFallback/ApiErrorFallback';
import { AxiosError } from 'axios';
import App from './App';

console.log('app_version: ', __APP_VERSION__);
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: (error): boolean => {
        return (
          error instanceof AxiosError &&
          !!error?.status &&
          InterceptedAPIStatus.includes(error?.status)
        );
      },
    },
  },
};

const queryClient = new QueryClient({
  ...queryClientConfig,
  queryCache: new QueryCache({}),
});

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
  }
}
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const enableAsync = async (): Promise<unknown> => {
  if (import.meta.env.VITE_ENVIRONMENT === 'production') {
    return true;
  }
  /*  /* const { default: whyDidYouRender } = await import('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  }); */
  return true;
};

enableAsync().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
});
